// extracted by mini-css-extract-plugin
export default {"bubbleBox":"_ConversationBubble_bubbleBox__q+caK","bubbleRight":"_ConversationBubble_bubbleRight__eCTn-","bubbleLeft":"_ConversationBubble_bubbleLeft__kKbbs"};